import {
	Typography,
	Grid,
	Stack,
	MenuItem,
	Box,
	Snackbar,
	Checkbox,
	FormControlLabel,
	FormGroup,
} from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import { StyledTextBoxv2 } from "../../components/ui/TextBox";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PhoneInput from "react-phone-input-2";
import { GreenContainedButton } from "../../components/ui/Buttons";
import {
	GetUserDetails,
	PostBusinessInfomation,
} from "../../services/auth.services";
import { geocodeByAddress } from "react-google-places-autocomplete";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { StyledDatePicker } from "../../components/ui/DatePicker";
import { formatLabel } from "../../utils/utilityFunctions";
import countryList from "react-select-country-list";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { REACT_APP_GOOGLE_API_KEY } from "../../utils/constants";

const boxStyle = {
	background: "#FFFFFF",
	p: 3,
	boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.04)",
	borderRadius: "10px",
};

export default function BusinessInfo({ updateStep }) {
	const value = localStorage.getItem("businessDetails");
	const businessName = localStorage.getItem("businessName");
	const [name] = (value || "").split(":");
	const [businessInfo, setbusinessInfo] = useState({
		name: {
			value: name === "NOT FOUND" ? "" : (name || businessName || ""),
			error: false,
			message: "Business Name is required",
		},
		registrationNo: {
			value: "",
			error: false,
			message: "Registration Number is required",
		},
		businessType: {
			value: "LLC",
			error: false,
			message: "Business Type is required",
		},
		industry: {
			value: "Private Label",
			error: false,
			message: "Segment is required",
		},
		connectedMarketPlaces: {
			value: "AMAZON",
			error: false,
			message: "Connected Marketplaces is required",
		},
		contactNo: {
			value: "",
			error: false,
			message: "Contact Number is required",
		},
		email: {
			value: "",
			error: false,
			message: "Email is required",
		},
		address: {
			value: "",
			error: false,
			message: "Address is required",
		},
		city: {
			value: "",
			error: false,
			message: "City is required",
		},
		state: {
			value: "",
			error: false,
			message: "State is required",
		},
		zipCode: {
			value: "",
			error: false,
			message: "Zip Code is required",
		},
		country: {
			value: "",
			error: false,
			message: "Country is required",
		},
		userUniqueId: {
			value: localStorage.getItem("uniqueId") || "",
			error: false,
			message: "Contact Number is required",
		},
		storeLink: {
			value: "",
			error: false,
			message: "Store Front link is required",
		},
		o_idType: {
			value: "NATIONAL_ID",
			error: false,
			message: "Store Front link is required",
		},
		o_fName: {
			value: "",
			error: false,
			message: "First Name is required",
		},
		o_lName: {
			value: "",
			error: false,
			message: "Last Name is required",
		},
		o_idPassportDl: {
			value: "",
			error: false,
			message: "National ID /Passport /Driving Licence  is required",
		},
		o_dateOfBirth: {
			value: moment().subtract(18, "years").toDate(),
			error: false,
			message: "Date Of Birth is required",
		},
		o_ssn: {
			value: "",
			error: false,
			message: "Social Security Number Required",
		},
		o_nationality: {
			value: "",
			error: false,
			message: "Nationality is required",
		},
		o_contactNumber: {
			value: "",
			error: false,
			message: "Contact Number is required",
		},
		o_email: {
			value: "",
			error: false,
			message: "Email is required",
		},
		o_address: {
			value: "",
			error: false,
			message: "Address is required",
		},
		o_city: {
			value: "",
			error: false,
			message: "City is required",
		},
		o_state: {
			value: "",
			error: false,
			message: "State is required",
		},
		o_zipCode: {
			value: "",
			error: false,
			message: "Zip Code is required",
		},
		o_country: {
			value: "",
			error: false,
			message: "Country is required",
		},
	});
	const [logisticAndFulfilment, setLogisticAndFulfilment] = useState([]);
	const [logisticAndFulfilmentError, setLogisticAndFulfilmentError] =
		useState(false);
	const [inputAddress, setInputAddress] = useState(null);
	const [inputOwnerAddress, setInputOwnerAddress] = useState(null);
	const [snackBarAlert, setSnackBarAlert] = useState(false);
	const [snackBarMessage, setSnackBarMessage] = useState("");
	const [businessTypeValue, setBusinessTypeValue] = useState("");
	const [usePersonalInfo, setUsePersonalInfo] = useState(false);
	const [userDetails, setUserDetails] = useState(null);
	const [useGoogleAutocompleteBusiness, setUseGoogleAutocompleteBusiness] =
		useState(true);
	const [useGoogleAutocomplete, setUseGoogleAutocomplete] = useState(true);
	const countryOptions = useMemo(() => countryList().getData(), []);

	const addressAPIKey = REACT_APP_GOOGLE_API_KEY;

	const options = [
		"Delivery Service Provider",
		"Warehouse and Fulfilment Provider",
		"Fulfillment by merchant",
		"Multi-Channel Fulfillment",
	];

	const fetchData = async () => {
		try {
			await GetUserDetails(localStorage.getItem("uniqueId")).then((data) => {
				setUserDetails(data);
			});
		} catch (error) {
			console.error("Error", error);
		}
	};

	useEffect(() => {
		if (inputAddress) {
			geocodeByAddress(inputAddress.label).then((place) => {
				let updatedBusinessInfo = {
					...businessInfo,
					address: { value: inputAddress.label },
				}; // Create a copy of userInfo

				for (var i = 0; i < place[0].address_components.length; i++) {
					var addressType = place[0].address_components[i].types[0];

					switch (addressType) {
						case "locality":
							updatedBusinessInfo.city.value =
								place[0].address_components[i].long_name;
							break;
						case "administrative_area_level_1":
							updatedBusinessInfo.state.value =
								place[0].address_components[i].long_name;
							break;
						case "country":
							updatedBusinessInfo.country.value =
								place[0].address_components[i].long_name;
							break;
						case "postal_code":
							updatedBusinessInfo.zipCode.value =
								place[0].address_components[i].long_name;
							break;
						default:
							break;
					}
				}

				setbusinessInfo(updatedBusinessInfo); // Update state once after loop
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inputAddress]);

	useEffect(() => {
		if (inputOwnerAddress) {
			geocodeByAddress(inputOwnerAddress.label).then((place) => {
				let updatedBusinessInfo = {
					...businessInfo,
					o_address: { value: inputOwnerAddress.label },
				}; // Create a copy of userInfo

				for (var i = 0; i < place[0].address_components.length; i++) {
					var addressType = place[0].address_components[i].types[0];

					switch (addressType) {
						case "locality":
							updatedBusinessInfo.o_city.value =
								place[0].address_components[i].long_name;
							break;
						case "administrative_area_level_1":
							updatedBusinessInfo.o_state.value =
								place[0].address_components[i].long_name;
							break;
						case "country":
							updatedBusinessInfo.o_country.value =
								place[0].address_components[i].long_name;
							break;
						case "postal_code":
							updatedBusinessInfo.o_zipCode.value =
								place[0].address_components[i].long_name;
							break;
						default:
							break;
					}
				}

				setbusinessInfo(updatedBusinessInfo); // Update state once after loop
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inputOwnerAddress]);

	useEffect(() => {
		// setInputAddress(null);
		fetchData();
		if (usePersonalInfo && userDetails) {
			setbusinessInfo({
				...businessInfo,
				o_contactNumber: {
					...businessInfo.o_contactNumber,
					value: userDetails.contactNo,
				},
				o_email: {
					...businessInfo.o_email,
					value: userDetails.email,
				},
				o_address: {
					...businessInfo.o_address,
					value: userDetails.address,
				},
				o_city: {
					...businessInfo.o_city,
					value: userDetails.city,
				},
				o_state: {
					...businessInfo.o_state,
					value: userDetails.state,
				},
				o_zipCode: {
					...businessInfo.o_zipCode,
					value: userDetails.zipCode,
				},
				o_country: {
					...businessInfo.o_country,
					value: userDetails.country,
				},
				o_fName: {
					...businessInfo.o_fName,
					value: userDetails.firstName,
				},
				o_lName: {
					...businessInfo.o_lName,
					value: userDetails.lastName,
				},
			});
		} else {
			setbusinessInfo({
				...businessInfo,
				o_contactNumber: {
					...businessInfo.o_contactNumber,
					value: "",
				},
				o_email: {
					...businessInfo.o_email,
					value: "",
				},
				o_address: {
					...businessInfo.o_address,
					value: "",
				},
				o_city: {
					...businessInfo.o_city,
					value: "",
				},
				o_state: {
					...businessInfo.o_state,
					value: "",
				},
				o_zipCode: {
					...businessInfo.o_zipCode,
					value: "",
				},
				o_country: {
					...businessInfo.o_country,
					value: "",
				},
				o_fName: {
					...businessInfo.o_fName,
					value: "",
				},
				o_lName: {
					...businessInfo.o_lName,
					value: "",
				},
			});
		}
		// eslint-disable-next-line
	}, [usePersonalInfo]);

	const handleCheckboxChange = (value) => {
		setLogisticAndFulfilment(
			(prev) =>
				prev.includes(value)
					? prev.filter((item) => item !== value) // Remove if unchecked
					: [...prev, value] // Add if checked
		);
	};

	const idOptions = ["NATIONAL_ID", "PASSPORT", "DRIVING_LICENSE"];

	const handleSubmit = (e) => {
		e.preventDefault();

		let updatedbusinessInfo = {
			...businessInfo,
			o_dateOfBirth: {
				...businessInfo.o_dateOfBirth,
				value: moment(businessInfo.o_dateOfBirth.value).format("L"),
			},
			businessType: {
				...businessInfo.businessType,
				value:
					businessInfo.businessType.value === "OTHER"
						? businessTypeValue
						: businessInfo.businessType.value,
			},
		};

		let propertyValues = Object.fromEntries(
			Object.entries(updatedbusinessInfo).map(([key, value]) => [
				key,
				value.value,
			])
		);

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		for (const key in updatedbusinessInfo) {
			if (
				(!updatedbusinessInfo[key].value ||
					updatedbusinessInfo[key].value.trim() === "") &&
				(key !== "o_ssn" || businessInfo.o_country.value === "United States")
			) {
				updatedbusinessInfo[key].error = true;
				setbusinessInfo({
					...businessInfo,
					[key]: { ...businessInfo.error, error: true },
				});
				setSnackBarAlert(true);
				setSnackBarMessage(`Please fill Required fields`);
			} else if (key === "o_contactNumber" || key === "contactNo") {
				const phoneNumber = parsePhoneNumberFromString(
					`+${updatedbusinessInfo[key].value}` || ""
				);
				if (!phoneNumber || !phoneNumber.isValid()) {
					updatedbusinessInfo[key].error = true;
					updatedbusinessInfo[key].message =
						"Please enter a valid phone number with at least 10 digits.";
					setSnackBarAlert(true);
					setSnackBarMessage("Please enter a valid contact number");
				} else {
					updatedbusinessInfo[key].error = false;
					updatedbusinessInfo[key].message = "";
				}
			} else {
				updatedbusinessInfo[key].error = false;
				if (
					key === "email" &&
					!emailRegex.test(updatedbusinessInfo[key].value)
				) {
					updatedbusinessInfo[key].error = true;
				}
			}
		}

		const hasError = Object.values(updatedbusinessInfo).some(
			(field) => field.error === true
		);

		if (logisticAndFulfilment.length <= 0) {
			setLogisticAndFulfilmentError(true);
		} else {
			setLogisticAndFulfilmentError(false);
		}

		updatedbusinessInfo = { ...businessInfo, logisticAndFulfilment };

		propertyValues = { ...propertyValues, logisticAndFulfilment };
		localStorage.setItem(
			"businessOwnerIdType",
			formatLabel(businessInfo.o_idType.value)
		);

		if (!hasError && !logisticAndFulfilmentError) {
			try {
				PostBusinessInfomation(propertyValues)
					.then((data) => {
						if (data.status === 200) {
							updateStep(3);
						} else if (data.status === 500) {
							setSnackBarAlert(true);
							setSnackBarMessage("Email already exists");
						} else if (data.status === 400) {
							setSnackBarAlert(true);
							setSnackBarMessage("Please fill all fields");
						} else {
							setSnackBarAlert(true);
							setSnackBarMessage(data.message);
						}
					})
					.catch((error) => {
						setSnackBarAlert(true);
						setSnackBarMessage(error.message);
					});
			} catch (error) {
				setSnackBarAlert(true);
				setSnackBarMessage("Somthing went wrong please try again");
				console.error("Error", error);
			}
		}
	};

	return (
		<div>
			<br></br>
			<Box sx={boxStyle}>
				<Stack
					direction="row"
					spacing={2}
					sx={{ color: "#093BA7" }}
					alignItems="center"
				>
					<FolderSharedIcon />
					<Typography variant="h5">
						Basic Information for Business Profile
					</Typography>
				</Stack>

				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Business Name
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your Business Name"
								value={businessInfo.name.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										name: {
											...businessInfo.name,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.name.error && businessInfo.name.value === ""
									? businessInfo.name.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Segment
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								value={businessInfo.industry.value}
								select
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										industry: {
											...businessInfo.industry,
											error: false,
											value: event.target.value,
										},
									})
								}
							>
								<MenuItem value="Private Label" key={1}>
									Private Label
								</MenuItem>
								<MenuItem value="Wholesale (Reseller)" key={2}>
									Wholesale (Reseller)
								</MenuItem>
								<MenuItem value="Dropshipping" key={3}>
									Dropshipping
								</MenuItem>
								<MenuItem value="Manufacturer (Own Brand)" key={4}>
									Manufacturer (Own Brand)
								</MenuItem>
								<MenuItem value="Aggregator (Multi-brand)" key={5}>
									Aggregator (Multi-brand)
								</MenuItem>
							</StyledTextBoxv2>
							<Typography variant="body3" color="red">
								{businessInfo.industry.error
									? businessInfo.industry.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Registration Number
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your Registration Number"
								value={businessInfo.registrationNo.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										registrationNo: {
											...businessInfo.registrationNo,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.registrationNo.error &&
									businessInfo.registrationNo.value === ""
									? businessInfo.registrationNo.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Business Type
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								value={businessInfo.businessType.value}
								select
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										businessType: {
											...businessInfo.businessType,
											error: false,
											value: event.target.value,
										},
									})
								}
							>
								<MenuItem value="LLC" key={1}>
									LLC
								</MenuItem>
								<MenuItem value="C-Corp" key={2}>
									C-Corp
								</MenuItem>
								<MenuItem value="S-Corp" key={3}>
									S-Corp
								</MenuItem>
								<MenuItem value="OTHER" key={4}>
									Other
								</MenuItem>
							</StyledTextBoxv2>
							{businessInfo.businessType.value === "OTHER" ? (
								<StyledTextBoxv2
									fullWidth
									placeholder="Business Type"
									value={businessTypeValue}
									onChange={(event) => setBusinessTypeValue(event.target.value)}
								/>
							) : (
								""
							)}
							<Typography variant="body3" color="red">
								{businessInfo.businessType.error
									? businessInfo.businessType.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Connected Market Places
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Connected Market Places"
								disabled
								value={businessInfo.connectedMarketPlaces.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										connectedMarketPlaces: {
											...businessInfo.connectedMarketPlaces,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.connectedMarketPlaces.error
									? businessInfo.connectedMarketPlaces.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Store Front Link
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your Store Front Link"
								value={businessInfo.storeLink.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										storeLink: {
											...businessInfo.storeLink,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.storeLink.error &&
									businessInfo.storeLink.value === ""
									? businessInfo.storeLink.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Logistic & Fulfillment Options
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<FormGroup>
								{options.map((option, index) => (
									<FormControlLabel
										key={index}
										control={
											<Checkbox
												value={option}
												checked={logisticAndFulfilment.includes(option)}
												onChange={() => {
													handleCheckboxChange(option);
													setLogisticAndFulfilmentError(false);
												}}
												size="small"
											/>
										}
										label={option}
									/>
								))}
							</FormGroup>
							<Typography variant="body3" color="red">
								{logisticAndFulfilmentError
									? "Select at least one of the Logistic & Fulfillment Options"
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Box>
			<br></br>
			<Box sx={boxStyle}>
				<Stack
					direction="row"
					spacing={2}
					sx={{ color: "#093BA7" }}
					alignItems="center"
				>
					<LocalPhoneIcon />
					<Typography variant="h5">Business Contact Information</Typography>
				</Stack>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Contact Number
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							{/* {businessInfo.contactNo.error ? (
								<PhoneInput
									country={"us"}
									inputStyle={{
										borderColor: "#d2302f",
									}}
									autoFormat={true}
									value={businessInfo.contactNo.value}
									onChange={(value) =>
										setbusinessInfo({
											...businessInfo,
											contactNo: { ...businessInfo.contactNo, error: false, value },
										})
									}
								/>
							) : ( */}
							<PhoneInput
								country={"us"}
								autoFormat={true}
								value={businessInfo.contactNo.value}
								onChange={(value) =>
									setbusinessInfo({
										...businessInfo,
										contactNo: {
											...businessInfo.contactNo,
											error: false,
											value,
										},
									})
								}
							/>
							{/* )} */}

							<Typography variant="body3" color="red">
								{businessInfo.contactNo.error
									? businessInfo.contactNo.value === ""
										? "Contact number is required"
										: "Please enter a valid phone number for the selected country."
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Email
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your business email eg: example@gmail.com"
								value={businessInfo.email.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										email: {
											...businessInfo.email,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.email.error ? businessInfo.email.message : ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Business Address
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<Stack direction="row" alignItems="center">
								<Checkbox
									checked={useGoogleAutocompleteBusiness}
									onClick={() => {
										setInputAddress(null);
										setbusinessInfo({
											...businessInfo,
											address: {
												...businessInfo.address,
												error: false,
												value: "",
											},
										});
										setUseGoogleAutocompleteBusiness(
											!useGoogleAutocompleteBusiness
										);
									}}
								/>
								<Typography variant="body2_light">
									Use Google Autocomplete
								</Typography>
							</Stack>
							{addressAPIKey && useGoogleAutocompleteBusiness ? (
								<GooglePlacesAutocomplete
									apiKey={addressAPIKey}
									selectProps={{
										value: inputAddress,
										onChange: setInputAddress,
										placeholder: "Search your business address",
										styles: {
											control: (provided) => ({
												...provided,
												border: "none",
												borderRadius: "4px",
												height: "2.5em",
												background: "#F9F9FB",
												color: "#28282A",
											}),
											placeholder: (provided) => ({
												...provided,
												color: "#c2c2c4",
											}),
										},
									}}
								/>
							) : (
								<StyledTextBoxv2
									fullWidth
									value={businessInfo.address.value}
									placeholder="Enter your business address"
									onChange={(event) =>
										setbusinessInfo({
											...businessInfo,
											address: {
												...businessInfo.address,
												error: false,
												value: event.target.value,
											},
										})
									}
								/>
							)}
							<Typography variant="body3" color="red">
								{businessInfo.address.error && businessInfo.address.value === ""
									? businessInfo.address.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								City / Town
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your business city or town"
								value={businessInfo.city.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										city: {
											...businessInfo.city,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.city.error && businessInfo.city.value === ""
									? businessInfo.city.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								State / Province / Region
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your business state, province, or region"
								value={businessInfo.state.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										state: {
											...businessInfo.state,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.state.error && businessInfo.state.value === ""
									? businessInfo.state.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Postal / ZIP Code
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your business Postal or ZIP Code"
								value={businessInfo.zipCode.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										zipCode: {
											...businessInfo.zipCode,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.zipCode.error && businessInfo.zipCode.value === ""
									? businessInfo.zipCode.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Country
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							{/* <StyledTextBoxv2 fullWidth placeholder="United State" value={businessInfo.country.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										country: {
											...businessInfo.country,
											value: event.target.value,
										},
									})
								} /> */}
							<StyledTextBoxv2
								fullWidth
								value={businessInfo.country.value}
								select
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										country: {
											...businessInfo.country,
											error: false,
											value: event.target.value,
										},
									})
								}
							>
								{countryOptions.map((data, index) => (
									<MenuItem value={data.label} key={index}>
										{data.label}
									</MenuItem>
								))}
							</StyledTextBoxv2>
							<Typography variant="body3" color="red">
								{businessInfo.country.error && businessInfo.country.value === ""
									? businessInfo.country.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Box>
			<br></br>
			<Box sx={boxStyle}>
				<Stack
					direction="row"
					spacing={2}
					sx={{ color: "#093BA7" }}
					alignItems="center"
				>
					<LocalPhoneIcon />
					<Typography variant="h5">
						Business Owner Contact Information - Should own more than 25% of the
						business
					</Typography>
					{localStorage.getItem("uniqueId") ? (
						<Stack direction="row" alignItems="center">
							<Checkbox
								checked={usePersonalInfo}
								onChange={(event) => setUsePersonalInfo(event.target.checked)}
							/>
							<Typography variant="body2" color="neutral.letter_Black">
								Use Personal information
							</Typography>
						</Stack>
					) : (
						""
					)}
				</Stack>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								First Name
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="First Name"
								value={businessInfo.o_fName.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_fName: {
											...businessInfo.o_fName,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_fName.error && businessInfo.o_fName.value === ""
									? businessInfo.o_fName.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Last Name
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Last Name"
								value={businessInfo.o_lName.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_lName: {
											...businessInfo.o_lName,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_lName.error && businessInfo.o_lName.value === ""
									? businessInfo.o_lName.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container>
						<Grid item xs={5} direction="row" alignItems="center">
							<Typography variant="body2" color="neutral.letter_Black">
								Identification Type
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								value={businessInfo.o_idType.value}
								select
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_idType: {
											...businessInfo.o_idType,
											error: false,
											value: event.target.value,
										},
									})
								}
							>
								{idOptions.map((option) => (
									<MenuItem key={option} value={option}>
										{formatLabel(option)}
									</MenuItem>
								))}
							</StyledTextBoxv2>
						</Grid>
						<Grid item xs={1} />
						<Grid item xs={6} direction="row" alignItems="center">
							<Typography variant="body2" color="neutral.letter_Black">
								{formatLabel(businessInfo.o_idType.value)}
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder={formatLabel(businessInfo.o_idType.value)}
								value={businessInfo.o_idPassportDl.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_idPassportDl: {
											...businessInfo.o_idPassportDl,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_idPassportDl.error &&
									businessInfo.o_idPassportDl.value === ""
									? businessInfo.o_idPassportDl.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Nationality
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Nationality"
								value={businessInfo.o_nationality.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_nationality: {
											...businessInfo.o_nationality,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_nationality.error
									? "Nationality is required"
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Date Of Birth
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<StyledDatePicker
									openTo="day"
									views={["year", "month", "day"]}
									value={businessInfo.o_dateOfBirth.value}
									maxDate={moment().subtract(18, "years").toDate()}
									onChange={(newValue) => {
										setbusinessInfo({
											...businessInfo,
											o_dateOfBirth: {
												...businessInfo.o_dateOfBirth,
												error: false,
												value: newValue,
											},
										});
									}}
								/>
							</LocalizationProvider>
							<Typography variant="body3" color="red">
								{businessInfo.o_dateOfBirth.error &&
									businessInfo.o_dateOfBirth.value === ""
									? businessInfo.o_dateOfBirth.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Social Security Number (Only for US Citizans)
								{businessInfo.o_country.value === "United States" && (
									<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
										*
									</Typography>
								)}
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Social Security Number"
								value={businessInfo.o_ssn.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_ssn: {
											...businessInfo.o_ssn,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_ssn.error &&
									(businessInfo.o_ssn.value === "" ||
										businessInfo.o_ssn.value === undefined)
									? "Social Security Number Required"
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Contact Number
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<PhoneInput
								country={"us"}
								autoFormat={true}
								value={businessInfo.o_contactNumber.value}
								onChange={(value) =>
									setbusinessInfo({
										...businessInfo,
										o_contactNumber: {
											...businessInfo.o_contactNumber,
											error: false,
											value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_contactNumber.error
									? businessInfo.o_contactNumber.value === ""
										? "Contact number is required"
										: "Please enter a valid phone number for the selected country."
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Email
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="example@gmail.com"
								value={businessInfo.o_email.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_email: {
											...businessInfo.o_email,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_email.error &&
									(businessInfo.o_email.value === "" ||
										businessInfo.o_email.value === undefined)
									? "Email is required"
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Address
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<Stack direction="row" alignItems="center">
								<Checkbox
									checked={useGoogleAutocomplete}
									onClick={() => {
										setInputOwnerAddress(null);
										setbusinessInfo({
											...businessInfo,
											o_address: {
												...businessInfo.o_address,
												error: false,
												value: "",
											},
										});
										setUseGoogleAutocomplete(!useGoogleAutocomplete);
									}}
								/>
								<Typography variant="body2_light">
									Use Google Autocomplete
								</Typography>
							</Stack>
							{addressAPIKey && useGoogleAutocomplete && !usePersonalInfo ? (
								<GooglePlacesAutocomplete
									apiKey={addressAPIKey}
									selectProps={{
										value: inputOwnerAddress,
										onChange: setInputOwnerAddress,
										placeholder: "Search your address",
										styles: {
											control: (provided) => ({
												...provided,
												border: "none",
												borderRadius: "4px",
												height: "2.5em",
												background: "#F9F9FB",
												color: "#28282A",
											}),
											placeholder: (provided) => ({
												...provided,
												color: "#c2c2c4",
											}),
										},
									}}
								/>
							) : (
								<StyledTextBoxv2
									fullWidth
									value={businessInfo.o_address.value}
									placeholder="Enter your address"
									onChange={(event) =>
										setbusinessInfo({
											...businessInfo,
											o_address: {
												...businessInfo.o_address,
												error: false,
												value: event.target.value,
											},
										})
									}
								/>
							)}
							<Typography variant="body3" color="red">
								{businessInfo.o_address.error &&
									businessInfo.o_address.value === ""
									? businessInfo.o_address.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								City / Town
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your city or town"
								value={businessInfo.o_city.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_city: {
											...businessInfo.o_city,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_city.error && businessInfo.o_city.value === ""
									? businessInfo.o_city.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								State / Province / Region
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your state, province, or region"
								value={businessInfo.o_state.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_state: {
											...businessInfo.o_state,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_state.error && businessInfo.o_state.value === ""
									? businessInfo.o_state.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Postal / ZIP Code
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your Postal or ZIP Code"
								value={businessInfo.o_zipCode.value}
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_zipCode: {
											...businessInfo.o_zipCode,
											error: false,
											value: event.target.value,
										},
									})
								}
							/>
							<Typography variant="body3" color="red">
								{businessInfo.o_zipCode.error &&
									businessInfo.o_zipCode.value === ""
									? businessInfo.o_zipCode.message
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Country
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								value={businessInfo.o_country.value}
								select
								onChange={(event) =>
									setbusinessInfo({
										...businessInfo,
										o_country: {
											...businessInfo.o_country,
											error: false,
											value: event.target.value,
										},
									})
								}
							>
								{countryOptions.map((data, index) => (
									<MenuItem value={data.label} key={index}>
										{data.label}
									</MenuItem>
								))}
							</StyledTextBoxv2>
							<Typography variant="body3" color="red">
								{businessInfo.o_country.error &&
									(businessInfo.o_country.value === "" ||
										businessInfo.o_country.value === undefined)
									? "Country is required"
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Box>
			<br></br>
			<Stack justifyContent="flex-end" alignItems="flex-end">
				<GreenContainedButton
					variant="contained"
					onClick={(e) => handleSubmit(e)}
					endIcon={<ArrowForwardIosIcon />}
				>
					Next
				</GreenContainedButton>
			</Stack>
			<br></br>
			<Snackbar
				open={snackBarAlert}
				onClose={() => setSnackBarAlert(false)}
				anchorOrigin={{ vertical: "top", horizontal: "left" }}
				sx={{ top: "0 !important", left: "0 !important", zIndex: 10000 }}
				autoHideDuration={6000}
			>
				<Box
					onClose={() => setSnackBarAlert(false)}
					sx={{ width: "100vw", background: "#F33535", p: 0.5 }}
				>
					<Stack
						direction="row"
						spacing={2}
						sx={{
							width: "100%",
							textAlign: "center",
							alignItems: "center",
							justifyContent: "center",
							color: "#FFFFFF",
						}}
					>
						<CancelOutlinedIcon fontSize="small" />
						<Typography variant="body2">{snackBarMessage}</Typography>
					</Stack>
				</Box>
			</Snackbar>
			<br></br>
		</div>
	);
}
